import './css/categories.css';


import AnimeShapes1 from './images/products/1.jpg';
import AnimeShapes2 from './images/products/2.jpg';
import AnimeShapes3 from './images/products/3.jpg';


import {Swiper,SwiperSlide} from 'swiper/react';

import 'swiper/css';
import 'swiper/css/effect-cube';

import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import {Autoplay,EffectCube,EffectCoverflow,Navigation,Pagination} from 'swiper';



function Categories(){
    return(
        <>
            
            <section className="categories-slider">
                <div className="slider">


                    
                <Swiper  grabCursor={true} slidesPerView={'auto'} navigation={{
                nextEl: '.next-btn',
                prevEl: '.prev-btn',
                }} pagination={true}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                modules={[Autoplay,EffectCoverflow,EffectCube,Navigation,Pagination]}
                >
                    <SwiperSlide>
                        <div className="category">
                            <a href="#">
                                <div className="slide">
                                <img src={AnimeShapes1} alt="animeproduct"/>
                                    <h1>مكياج أحلى ساكورا </h1>
                                </div>
                            </a>
                        </div>

                    </SwiperSlide>


                    <SwiperSlide>
                        
                    <div className="category">
                        <a href="#">
                        <div className="slide">
                            <img src={AnimeShapes2} alt="animeproduct"/>                  
                            <h1>مكياج أحلى ساكورا </h1>
                        </div>
                        </a>
                    </div>


                    </SwiperSlide>


                    
                    <SwiperSlide>
                        
                    <div className="category">
                        <a href="#">
                        <div className="slide">
                            <img src={AnimeShapes2} alt="animeproduct"/>

                            <h1>مكياج أحلى ساكورا </h1>
                        </div>
                        </a>
                    </div>
                        

                    </SwiperSlide>


                    
                    <SwiperSlide>
                        
                        
                    <div className="category">
                        <a href="#">
                        <div className="slide">
                        <img src={AnimeShapes3} alt="animeproduct"/>
                            <h1>مكياج أحلى ساكورا </h1>
                        </div>
                        </a>
                    </div>

                    </SwiperSlide>



                    
                    <SwiperSlide>
                        
                        
                    <div className="category">
                        <a href="#">
                        <div className="slide">
                        <img src={AnimeShapes1} alt="animeproduct"/>
                            <h1>مكياج أحلى ساكورا </h1>
                        </div>
                        </a>
                    </div>

                    </SwiperSlide>

                    
                    <SwiperSlide>
                        
                        
                        <div className="category">
                            <a href="#">
                            <div className="slide">
                            <img src={AnimeShapes1} alt="animeproduct"/>
                                <h1>مكياج أحلى ساكورا </h1>
                            </div>
                            </a>
                        </div>

                    </SwiperSlide>


                    <SwiperSlide>
                        <div className="category">
                            <a href="#">
                            <div className="slide">
                            <img src={AnimeShapes3} alt="animeproduct"/>
                                <h1>مكياج أحلى ساكورا </h1>
                            </div>
                            </a>
                        </div>
                        

                    </SwiperSlide>


                    
                    
                    <SwiperSlide>
                        
                        
                    <div className="category">
                        <a href="#">
                        <div className="slide">
                        <img src={AnimeShapes3} alt="animeproduct"/>
                            <h1>مكياج أحلى ساكورا </h1>
                        </div>
                        </a>
                    </div>

                    </SwiperSlide>



                    
                    <SwiperSlide>
                        
                        
                    <div className="category">
                        <a href="#">
                        <div className="slide">
                        <img src={AnimeShapes1} alt="animeproduct"/>
                            <h1>مكياج أحلى ساكورا </h1>
                        </div>
                        </a>
                    </div>

                    </SwiperSlide>

                    
                    <SwiperSlide>
                        
                        
                        <div className="category">
                            <a href="#">
                            <div className="slide">
                            <img src={AnimeShapes1} alt="animeproduct"/>
                                <h1>مكياج أحلى ساكورا </h1>
                            </div>
                            </a>
                        </div>

                    </SwiperSlide>


                    <SwiperSlide>
                        <div className="category">
                            <a href="#">
                            <div className="slide">
                            <img src={AnimeShapes3} alt="animeproduct"/>
                                <h1>مكياج أحلى ساكورا </h1>
                            </div>
                            </a>
                        </div>
                        

                    </SwiperSlide>
                </Swiper>

                    

                    






                
                </div>
            </section>




        </>
    )
}

export default Categories;